import './style.css';
import { bootstrapApp } from './app/bootstrap.js';

void bootstrapApp();
